<template>
  <colgroup class="rc-title__colgroup">
    <col
      v-for="(item,index) in columns"
      :key="'colgroup_'+index"
      :style="item.data.staticStyle"
      v-bind="getAttrs(item)">
  </colgroup>
</template>
<script type="text/ecmascript-6">
  import getParentInfo from './getParentInfo'

  export default {
    name: 'TableColgroup',
    mixins: [getParentInfo]
  }
</script>
<style rel="stylesheet/css" type="text/css" lang="scss">
  .table_title_colgroup {
    display: table-column-group;

    .table_title_col {
      display: table-column;
    }
  }
</style>
